import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/shadcn/card.tsx";

import React, { useEffect, useState } from "react";
import { Model } from "@/pages/chatbot/ai_settings/ModelList.tsx";
import { useTranslation } from "react-i18next";
import Tooltip from "@/components/Tooltip.tsx";
import { Badge } from "@/components/shadcn/badge.tsx";

export interface ModelCardProps {
  model: Model;
  showDesc: boolean;
  onModelChange?: (model: Model) => void;
}

export function ModelCard({
  model,
  showDesc,
  onModelChange,
}: ModelCardProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <Card
      className="mt-2 hover:bg-gray-100 cursor-pointer"
      onClick={() => {
        onModelChange && onModelChange(model);
      }}
    >
      <CardHeader>
        <CardTitle>{model.name}</CardTitle>
        <CardDescription className="flex items-center">
          <span className="border-l-2 pl-2 mr-2 hidden sm:inline-block">
            {model.id}
          </span>
          <span className="border-l-2 pl-2 mr-2 hidden sm:inline-block">{`${t(
            "models.published",
          )}: ${new Date(model.created * 1000).toLocaleDateString()}`}</span>

          {!model.price && (
            <>
              <span className="border-l-2 pl-2">{`${t("models.price")}: ${
                model.credits
              } credits`}</span>
              <Tooltip noFill={true}>{t("models.price_desc")}</Tooltip>
            </>
          )}

          {model.price && model.price.input != 0 && (
            <>
              <span className="border-l-2 pl-2">
                {t("models.context")}&nbsp;
                <span className="font-semibold">
                  {(model.price.input * 1000).toFixed(2)}
                </span>
                {model.price.currency} /&nbsp;{t("models.generation")}&nbsp;
                <span className="font-semibold">
                  {(model.price.output * 1000).toFixed(2)}
                </span>
                {model.price.currency}
              </span>
              <div className="hidden sm:inline-block">
                <Tooltip>{t("models.tokens_price_desc")}</Tooltip>
              </div>
            </>
          )}

          {model.price && model.price.input == 0 && (
            <Badge>{t("models.free")}</Badge>
          )}
        </CardDescription>
      </CardHeader>
    </Card>
  );
}
